import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {useAmplitudeLeadFormStartTracking} from "../../application/hooks/use_amplitude_lead_form_start_tracking";
import {useLeadData} from "../../application/hooks/use_lead_data";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {useAppSelector} from "../../store/hooks";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

interface UseUnlockChoiceLeadFormStartTrackingParams {
    trackingContext: IAmplitudeLeadFormTrackingContext | null;
    source: ApplicationSource | null;
    sourceSection: ApplicationSourceSection | null;
    isReady: boolean;
    vendorId: number | null;
}

/**
 * The lead forms of the unlock choice are its own screens (the choice taking over a lead button, the price negotiation),
 * so no lead form reports their start - the choice reports it instead, once per shown screen
 */
export const useUnlockChoiceLeadFormStartTracking = ({
    trackingContext,
    source,
    sourceSection,
    isReady,
    vendorId
}: UseUnlockChoiceLeadFormStartTrackingParams) => {
    const {offerId, propertyId} = useAppSelector((state) => state.registrationFlow);
    const {data: userProfile} = useGetUserProfileQuery();
    const leadData = useLeadData({vendorId: vendorId ?? 0, offerId, propertyId, skipFetch: !trackingContext || vendorId === null});

    useAmplitudeLeadFormStartTracking({
        trackingContext,
        leadData: leadData ?? undefined,
        source,
        sourceSection,
        initialLeadFormValues: userProfile
            ? {name: userProfile.name ?? "", email: userProfile.email ?? "", phone: getPhoneDataFromString(userProfile.phone ?? "")}
            : null,
        isReady
    });
};
import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {useAmplitudeLeadFormStartTracking} from "../../application/hooks/use_amplitude_lead_form_start_tracking";
import {useLeadData} from "../../application/hooks/use_lead_data";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {useAppSelector} from "../../store/hooks";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";

interface UseUnlockChoiceLeadFormStartTrackingParams {
    trackingContext: IAmplitudeLeadFormTrackingContext | null;
    source: ApplicationSource | null;
    sourceSection: ApplicationSourceSection | null;
    isReady: boolean;
    vendorId: number | null;
}

/**
 * The lead forms of the unlock choice are its own screens (the choice taking over a lead button, the price negotiation),
 * so no lead form reports their start - the choice reports it instead, once per shown screen
 */
export const useUnlockChoiceLeadFormStartTracking = ({
    trackingContext,
    source,
    sourceSection,
    isReady,
    vendorId
}: UseUnlockChoiceLeadFormStartTrackingParams) => {
    const {offerId, propertyId} = useAppSelector((state) => state.registrationFlow);
    const {data: userProfile} = useGetUserProfileQuery();
    const leadData = useLeadData({vendorId: vendorId ?? 0, offerId, propertyId, skipFetch: !trackingContext || vendorId === null});

    useAmplitudeLeadFormStartTracking({
        trackingContext,
        leadData: leadData ?? undefined,
        source,
        sourceSection,
        initialLeadFormValues: userProfile
            ? {name: userProfile.name ?? "", email: userProfile.email ?? "", phone: getPhoneDataFromString(userProfile.phone ?? "")}
            : null,
        isReady
    });
};
